import styled from "styled-components"

const EventsItem = styled.div`
  &:hover div:first-of-type::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_light};
  }
`

export { EventsItem }
